var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.475 7.1087C6.475 5.39043 7.828 4 9.5 4C11.172 4 12.525 5.39043 12.525 7.1087C12.525 8.82696 11.172 10.2174 9.5 10.2174C7.828 10.2174 6.475 8.82696 6.475 7.1087ZM11.2023 10.4972C10.6908 10.7685 10.1133 10.9239 9.5 10.9239C8.88675 10.9239 8.30925 10.7685 7.79775 10.4972C5.595 11.232 4 13.3572 4 15.8696V17H15V15.8696C15 13.3572 13.405 11.232 11.2023 10.4972Z",
    fill: "url(#paint0_linear_985_6248)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_985_6248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.475 6.1087C7.475 4.39043 8.828 3 10.5 3C12.172 3 13.525 4.39043 13.525 6.1087C13.525 7.82696 12.172 9.21739 10.5 9.21739C8.828 9.21739 7.475 7.82696 7.475 6.1087ZM12.2023 9.49717C11.6908 9.76848 11.1133 9.92391 10.5 9.92391C9.88675 9.92391 9.30925 9.76848 8.79775 9.49717C6.595 10.232 5 12.3572 5 14.8696V16H16V14.8696C16 12.3572 14.405 10.232 12.2023 9.49717Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_985_6248",
    x: 2.7,
    y: 0.7,
    width: 15.6,
    height: 17.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_985_6248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_985_6248",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_985_6248",
    x1: 9.5,
    y1: 17,
    x2: 9.5,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FB2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.7cc9537992ff130494f66d44d5a6e705.svg";
export { ForwardRef as ReactComponent };